module.exports = __webpack_public_path__ + "static/taylor-parks-plat-map-f34752830238e791935dc3df797d944d.jpg";